import { PRONOUN_OPTIONS } from '../constants';

export const getCharacterCountColor = (current: number, max: number) => {
    const percentage = (current / max) * 100;
    if (percentage >= 90) return 'text-red-500';
    if (percentage >= 75) return 'text-yellow-500';
    return 'text-gray-500';
};

export const getMaxLength = (field: string): number => {
    const VALIDATION = {
        MIN_NAME_LENGTH: 2,
        MAX_NAME_LENGTH: 50,
        MIN_PRONOUNS_LENGTH: 0,
        MAX_PRONOUNS_LENGTH: 20,
        MIN_BIO_LENGTH: 10,
        MAX_BIO_LENGTH: 500,
        MIN_EXPERIENCE_LENGTH: 10,
        MAX_EXPERIENCE_LENGTH: 1000,
        MIN_TESTIMONIALS_LENGTH: 10,
        MAX_TESTIMONIALS_LENGTH: 500,
        MIN_OTHER_LENGTH: 0,
        MAX_OTHER_LENGTH: 50000,
        MIN_URL_LENGTH: 3,
        MAX_URL_LENGTH: 50,
    };

    switch (field) {
        case 'name': return VALIDATION.MAX_NAME_LENGTH;
        case 'pronouns': return VALIDATION.MAX_PRONOUNS_LENGTH;
        case 'bio': return VALIDATION.MAX_BIO_LENGTH;
        case 'experience': return VALIDATION.MAX_EXPERIENCE_LENGTH;
        case 'testimonials': return VALIDATION.MAX_TESTIMONIALS_LENGTH;
        case 'other': return VALIDATION.MAX_OTHER_LENGTH;
        case 'unique_url': return VALIDATION.MAX_URL_LENGTH;
        default: return 1000;
    }
};

export const getMinLength = (field: string): number => {
    const VALIDATION = {
        MIN_NAME_LENGTH: 2,
        MIN_BIO_LENGTH: 10,
        MIN_EXPERIENCE_LENGTH: 10,
        MIN_URL_LENGTH: 3,
    };

    switch (field) {
        case 'name': return VALIDATION.MIN_NAME_LENGTH;
        case 'bio': return VALIDATION.MIN_BIO_LENGTH;
        case 'experience': return VALIDATION.MIN_EXPERIENCE_LENGTH;
        case 'unique_url': return VALIDATION.MIN_URL_LENGTH;
        default: return 0;
    }
};

export const isFieldValid = (field: string, value: string): boolean => {
    const minLength = getMinLength(field);
    return value.length >= minLength;
};

export const validateField = (field: string, value: string): string | null => {
    const VALIDATION = {
        MIN_NAME_LENGTH: 2,
        MAX_NAME_LENGTH: 50,
        MIN_BIO_LENGTH: 10,
        MAX_BIO_LENGTH: 500,
        MIN_EXPERIENCE_LENGTH: 10,
        MAX_EXPERIENCE_LENGTH: 1000,
        MAX_OTHER_LENGTH: 50000,
        MIN_URL_LENGTH: 3,
        MAX_URL_LENGTH: 50,
    };

    switch (field) {
        case 'name':
            if (value.length < VALIDATION.MIN_NAME_LENGTH) {
                return `Name must be at least ${VALIDATION.MIN_NAME_LENGTH} characters long`;
            }
            if (value.length > VALIDATION.MAX_NAME_LENGTH) {
                return `Name must be no more than ${VALIDATION.MAX_NAME_LENGTH} characters long`;
            }
            break;
        case 'pronouns':
            if (!value) {
                return 'Please select pronouns';
            }
            if (!PRONOUN_OPTIONS.includes(value as any)) {
                return 'Please select a valid pronoun option';
            }
            break;
        case 'bio':
            if (value.length < VALIDATION.MIN_BIO_LENGTH) {
                return `Bio must be at least ${VALIDATION.MIN_BIO_LENGTH} characters long`;
            }
            if (value.length > VALIDATION.MAX_BIO_LENGTH) {
                return `Bio must be no more than ${VALIDATION.MAX_BIO_LENGTH} characters long`;
            }
            break;
        case 'experience':
            if (value.length < VALIDATION.MIN_EXPERIENCE_LENGTH) {
                return `Experience must be at least ${VALIDATION.MIN_EXPERIENCE_LENGTH} characters long`;
            }
            if (value.length > VALIDATION.MAX_EXPERIENCE_LENGTH) {
                return `Experience must be no more than ${VALIDATION.MAX_EXPERIENCE_LENGTH} characters long`;
            }
            break;
        case 'other':
            if (value.length > VALIDATION.MAX_OTHER_LENGTH) {
                return `Other information must be no more than ${VALIDATION.MAX_OTHER_LENGTH} characters long`;
            }
            break;
        case 'unique_url':
            if (value.length < VALIDATION.MIN_URL_LENGTH) {
                return `URL handle must be at least ${VALIDATION.MIN_URL_LENGTH} characters long`;
            }
            if (value.length > VALIDATION.MAX_URL_LENGTH) {
                return `URL handle must be no more than ${VALIDATION.MAX_URL_LENGTH} characters long`;
            }
            // Check for valid URL handle format (only lowercase letters, numbers, and hyphens)
            if (!/^[a-z0-9-]+$/.test(value)) {
                return 'URL handle can only contain lowercase letters, numbers, and hyphens';
            }
            // Check that it doesn't start or end with a hyphen
            if (value.startsWith('-') || value.endsWith('-')) {
                return 'URL handle cannot start or end with a hyphen';
            }
            // Check for consecutive hyphens
            if (value.includes('--')) {
                return 'URL handle cannot contain consecutive hyphens';
            }
            break;
    }
    return null;
};
